import { Grid } from '@material-ui/core';
import React, { ReactNode } from 'react';

interface AppLayoutProps {
    children: ReactNode;
}

const AppLayout = ({ children }: AppLayoutProps) => (
    <Grid item xs={12} style={{ marginTop: '20px', marginBottom: '20px' }}>
        {children}
    </Grid>
);

export default AppLayout;
